import { NavLink } from 'react-router-dom';
import classes from './Header.module.css';

interface DesktopNavProps {
  homeHref: string;
  logoSrc: string;
  brandName: string;
}

export const DesktopNav = ({ homeHref, logoSrc, brandName }: DesktopNavProps) => {
  return (
    <nav className={classes.desktopNav} aria-label="Primary navigation">
      <NavLink to={homeHref} className={classes.brand}>
        <img src={logoSrc} alt="" className={classes.brandIcon} />
        <span className={classes.brandText}>{brandName}</span>
      </NavLink>
    </nav>
  );
};
